import { useRef, useMemo } from "react";
import { useUserContext } from "../user";
import { createApi, TaskListeners, SaveQueues, TasksById, AppContentAPIContext, SectionListeners, SectionsById, TasksInSectionListeners, SectionsInChapterListeners, ChapterListeners, ChaptersById, CompletedSectionsCountListeners } from "./appContentHooks";

export function AppContentProvider({ children }) {
    const { profile } = useUserContext();
    const userId = profile?.user_id;

    const saveQueues = useRef<SaveQueues>(new Map());

    const taskListeners = useRef<TaskListeners>(new Map());
    const sectionListeners = useRef<SectionListeners>(new Map());
    const chapterListeners = useRef<ChapterListeners>(new Map());

    const tasksInSectionListeners = useRef<TasksInSectionListeners>(new Map());
    const sectionsInChapterListeners = useRef<SectionsInChapterListeners>(new Map());

    const completedSectionCountListeners = useRef<CompletedSectionsCountListeners>([]);

    const taskStates = useRef<TasksById>(new Map());
    const sectionStates = useRef<SectionsById>(new Map());
    const chapterStates = useRef<ChaptersById>(new Map());

    const completedSectionCount = useRef(0);

    const apiRef = useMemo(() => createApi(
        {
            userId,
            saveQueues,

            taskStates,
            sectionStates,
            chapterStates,

            completedSectionCount,

            taskListeners,
            sectionListeners,
            chapterListeners,

            tasksInSectionListeners,
            sectionsInChapterListeners,
            completedSectionCountListeners,
        }
    ), [userId]);

    return (
        <AppContentAPIContext.Provider value={apiRef}>
            {children}
        </AppContentAPIContext.Provider>
    );
}